var current = 0;


function nextStep(){
    
    var target = $('.acc-content[data-stepcode="'+(current_step)+'"] form');

    var step = current + 1;
    var form = {};
    if(current_step!='payment_information' && target.length>1){
        target.each(function(){
            var form_data = $(this).serializeArray();
            var name = $(this).attr('name');
            form[name] = {};
            form_data.forEach(function (element) {
                form[name][element.name] = element.value;
            });
        });

    }else{
        var form_data = target.serializeArray();


        form_data.forEach(function (element) {
            form[element.name] = element.value;
        });

    }

    if(current_step === 'order_review'){
        $('body').prepend('<div class="loading blocking text-center white-text"></div>');
    }else{
        $('body').prepend('<div class="loading blocking"/>');
    }


    $.ajax({

        data:{
            module:'sales',
            action:'register-step',
            step:current_step,
            form_data:form
        },

        error:function(data){

            errorResponse(data,form);

            $('body .loading').fadeOut('fast',function(){
                $(this).remove();
            });
        },

        success:function(data){

            if(typeof data ==='object' && data.status === 'ok' && data.next_step){

                $('body .loading').fadeOut('fast',function(){
                    $(this).remove();
                });
                $('.acc .acc-content[data-stepcode="'+data.next_step+'"]').html(data.markup);

                callbacks('.acc .acc-content[data-stepcode="'+data.next_step+'"]');

                $('.acc .acc-content[data-stepcode="'+data.next_step+'"]').next().html(data.sidebar_markup);

                current = $('.acc .acc-content[data-stepcode="'+data.next_step+'"]').data('stepcount');
                $('.check-out-nav a[data-stepcode="'+data.next_step+'"]:visible').removeClass('disabled').trigger('click');

                skinFormElements('.acc .acc-content[data-stepcode="'+data.next_step+'"]');


                if(typeof(ga)!=='undefined'){
                    ga('send', 'pageview', '/checkout/'+data.next_step+'.html');
                }

                initCheckboxes();

            }else if(typeof data =='object' && data.status === 'ok' && data.redirect){
                eraseCookie('ML_CHECKOUT_ERROR');

                if(typeof(data.redirect_data)!=='undefined'){
                    post(data.redirect,data.redirect_data);
                }else{
                    window.location = data.redirect;
                }
                return false;
            }else if(typeof(data.error) !== 'undefined'){
                $('body .loading').fadeOut('fast',function(){
                    $(this).remove();
                });
                setCookie('ML_CHECKOUT_ERROR',1,1);
                if( current_step =='billing_information'){
                    errorResponse(data,form);
                }else{
                    form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error',data.error);

                    if(typeof(data.error_code) !== 'undefined' && data.error_code === 33){
                        $('.check-out-nav a[data-stepcode="billing_information"]').trigger('click');
                        scroll2position(0);
                    }else if(typeof(data.error_code) !== 'undefined' && data.error_code === 11){
                        $('.check-out-nav a[data-stepcode="payment_information"]').trigger('click');
                        scroll2position(0);
                    }
                }

            }

            scroll2position(0);
            return false;
        }
    });
}

function forceAddressSelection(){
    $('.bogus-address:visible').closest('form').find('input[name="usps_validated"]').val(1);
    $('.bogus-address:visible').removeClass('bogus-address').popover('destroy');
    $('.checkout-next-step:visible').trigger('click');
}
function forceAddress(){
    $('.bogus-address:visible').closest('form').find('input[name="usps_validated"]').val(1);
    $('.bogus-address:visible').closest('form').submit();
    $('.bogus-address:visible').removeClass('bogus-address').popover('destroy');
}

function useCorrectedAddress(){
    $('.bogus-address:visible').closest('form').find('input[name="usps_validated"]').val(0);
    $('.bogus-address:visible').closest('form').find('input[name="usps_use_suggested"]').val(1);
    $('.bogus-address:visible').removeClass('bogus-address').popover('destroy');
    $('.checkout-next-step:visible').trigger('click');
}

function closeAddressErrorPopover(){
    if($('.bogus-address:visible').length > 0){
        $('.bogus-address:visible').removeClass('bogus-address').popover('destroy');

        if($('input[name="address_id"]:checked').val()!='new-address'){
            $('input[name="address_id"]').iCheck('uncheck');
        }
    }

}
function add_new_address(){

    $('input[name="address_id"][value="new-address"]').iCheck('check');
    $('.bogus-address:visible').removeClass('bogus-address').popover('destroy');
    setTimeout(function(){
        scroll2position( $(window).height());
    },500);
}

function errorResponse($error,form_data){
    var message = '',target,force_action,actions,placement;
    if($error){
        if($error.responseJSON){
            message = '<h4>'+$error.responseJSON.error+'</h4>';
        }else if($error.responseText){
            message = '<h4>'+$error.responseText+'</h4>';
        }else if($error.error){
            message = '<h4>'+$error.error+'</h4>';
        }


        if(form_data.address_id === 'new-address'){
            target = $('.address-fields:visible');
            force_action = 'forceAddress';
            placement = 'top';

            actions = '<br><div class="btn-actions"><a href="#" class="master-btn" onclick="'+force_action+'();return false;">Use Address As Entered</a> <div>or</div> <a href="#" class="master-btn" onclick="closeAddressErrorPopover();return false;">Correct Address and try again</a></div>';

            if(message.indexOf('Is this your address')!=-1){
                actions = '<br><div class="btn-actions"><a href="#" class="master-btn" onclick="'+force_action+'();return false;">Use Address As Entered</a> <div>or</div> <a href="#" class="master-btn" onclick="useCorrectedAddress();return false;">Use Corrected Address</a></div>';
            }


        }else{
            target = $('input[name="address_id"][value="'+form_data.address_id+'"]:checked').closest('.panel.panel-default');
            force_action = 'forceAddressSelection';
            placement = 'bottom';
            if(message.indexOf('Is this your address')>=0){
                actions = '<br><div class="btn-actions" style="white-space: nowrap"><a href="#" class="master-btn" onclick="'+force_action+'();return false;">Use Address As Entered</a> <div>or</div> <a style="margin-left:10px;" href="#" class="master-btn" onclick="useCorrectedAddress();return false;">Use Corrected Address</a></div>';
            }else{
                message = '<p>The address selected appears to be be invalid or requires additional information.</p>';
                actions = '<br><div class="btn-actions" style="white-space: nowrap"><a href="#" class="master-btn"onclick="add_new_address();return false;">Add new Address</a> <div>or</div> <a style="margin-left:10px;" href="#" class="master-btn" onclick="closeAddressErrorPopover();return false;">Select a Different Address</a></div>';
            }
        }

        message += actions;
        message += '<br><span><span class="asterix"><i class="fa fa-exclamation-triangle"></i> Please note: </span>inaccurate addresses may result in shipment delays</span>';
        target.addClass('bogus-address');

        $('.bogus-address:visible').popover({
            placement:placement,
            title:'error',
            content:message,
            trigger:'manual',
            container:'.acc-content[data-stepcode="'+(current_step)+'"] form',
            html:true,
            template:'<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>'
        });
        $('.bogus-address:visible').popover('show');
    }else{
        form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error','An error occurred');
    }
}
function validateUser(form,callback){

        form.validate({
            rules: {
                'name':'required',
                'surname':'required',
                'email':'required',
                'password':'required'
            },
            messages:{
                'name':'required',
                'surname':'required',
                'email':'required',
                'password':'required'
            },
            submitHandler: callback
        });
        form.submit();
}
function validateAddress(form,callback){
    if( form.find('select[name="address_id"] option:selected').val() !== 'new-address' && 	form.find('select[name="address_id"] option:selected').val() !== '' && 	form.find('select[name="address_id"] option:selected').val() > 0 ){
        callback();
    }else{
       form.validate({
            rules: {
                'address_id':'required',
                'name':'required',
                'surname':'required',
                'address':'required',
                'city':'required',
                'state':'required',
                 'pc':'required',
                'country':'required',
                'phone':'required'
            },
            messages:{
                'address_id':'required',
                'name':'Required',
                'surname':'Required',
                'address':'Required',
                'city':'Required',
                'state':'Required',
                'pc':'Required',
                'country':'Required',
                'phone':'Required'
            },
            submitHandler: callback
        });
        form.submit();
    }
}

function validateCC(form,callback){
    if( form.find('select[name="address_id"] option:selected').val() !== 'new-address' && 	form.find('select[name="address_id"] option:selected').val() !== '' && 	form.find('select[name="address_id"] option:selected').val() > 0 ){
        callback();
    }else{
        $(form).validate({
            rules: {
                'cc_owner':'required',
                'cc_type':'required',
                'cc_number':{
                    required:true,
                    creditcard:true
                },
                'cc_exp_month':'required',
                'cc_exp_year':'required',
                'cc_cid':{
                    required:true,
                    rangelength:[3,4]

                }
            },
            messages:{
                'email':'Required'
            },
            submitHandler: callback
        });
        form.submit();
    }
}

function validateEPS(form,callback){
    $(form).validate({
        rules: {
            'brand':'required'
        },
        messages:{
            'brand':'Required'
        },
        submitHandler: callback
    });
    form.submit();
}

function validateGiropay(form,callback){
    $(form).validate({
        rules: {
            'sort_code':'required'
        },
        messages:{
            'sort_code':'Required'
        },
        submitHandler: callback
    });
    form.submit();
}

function initCheckOut(){

    if(typeof(ga)!=='undefined'){
        ga('send', 'pageview', '/checkout/'+current_step+'.html');
    }
    setTimeout(function(){
        $('.check-out-nav a[data-stepcode="'+current_step+'"]:visible').trigger('click');
    },500);

}

$(document).ready(function(){

    $(document).on('change','select[name="country"]',function(){
        var val = $(this).val();
        if($(this).val()==1 || $(this).val()==2){
            $('.state-dropdown').show();
            $('.state-dropdown option[data-country="'+$(this).val()+'"]').show();
            $('.state-dropdown option[data-country!="'+$(this).val()+'"]').hide();
        }else{
            $('.state-dropdown').hide();
        }
    });

    $(document).on('change','input:radio[name="payment_method"]',function(){
        var method = $(this).val(),
            m = $('#payment_method_'+method);
        if(!m.is(':visible')){
            $('.payment_method').slideUp('slow');

            m.slideDown('slow');
            skinDropDowns('#payment_method_'+method+' select');
        }
    });

    $(document).on('click','.checkout-step-chooser',function(){
        var c = $(this).data('stepcode');
        $('.check-out-nav a[data-stepcode="'+c+'"]').trigger('click');
        scroll2position(0);
        return false;
    });

    $(document).on('click','.check-out-nav li > a:visible',function(){

        if($(this).hasClass('disabled') || $(this).hasClass('active')) return false;
        //if($(this).data('stepcode') === 'order_review') return false;

        $('.check-out-nav li > a.active').removeClass('active');

        $(this).addClass('active');

        $('.acc .acc-content').removeClass('open');

        $('.acc .acc-content[data-stepcount="'+$(this).data('stepcount')+'"]').addClass('open');

        $('.acc .acc-content').parent().hide();
        $('.acc .open').parent().show();
        skinDropDowns('.acc .acc-content.open select:visible');


        current_step = $('.acc').find('.open').data('stepcode');
        var current_step_id = $('.acc').find('.open').data('stepcount');

        $('.acc .acc-content').each(function(){
            var step_id = $(this).data('stepcount');

            if(step_id>current_step_id){
                $(this).prev().addClass('disabled');
            }
        });

        return false;
    });



    $(document).on('click','.checkout-next-step',function(){
        var target = $(this).closest('form');
        var step = $(this).closest('.acc-content').data('stepcode');
        switch(step){
            case 'user_information':

                validateUser(target,nextStep);
                break;
            case 'billing_information': case 'shipping_information':

                validateAddress(target,nextStep);
                break;
            case 'payment_information':
                var method = $('input:radio[name="payment_method"]:checked').val();
                if(typeof(method) === 'undefined'){
                    form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error','No Payment Method Selected');
                }else if(method === 'credit_card'){
                    nextStep();//validateCC(target,nextStep);
                }else if(method === 'eps'){
                    validateEPS(target,nextStep);
                }else if(method === 'giropay'){
                    validateGiropay(target,nextStep);
                }else{
                    nextStep();
                }
                break;
            case 'shipping_method':
                var check_address = false;

                if($('input[name="delivery_method"]:checked').val()!==0){
                    check_address = true;
                }

                if(check_address){
                    validateAddress(target,validateShippingMethod);
                }else{
                    nextStep();
                }

                break;
            case 'delivery_method':
                nextStep();
                break;
            case 'order_review':
                nextStep();
                break;
        }
        return false;
    });

    $(document).on('change','input[name="address_id"]', function(event){
        // $('.address-selection').addClass('btn-primary').removeClass('btn-default').removeClass('active');
        $('.address-selection .unselected').removeClass('hidden');
        $('.address-selection .selected').addClass('hidden');
        // $(this).removeClass('btn-primary').addClass('btn-default');
        $(this).find('.unselected').addClass('hidden');
        $(this).find('.selected').removeClass('hidden');

        if($(this).val() === 'new-address'){

            $(this).closest('.acc-content').find('.address-form').fadeIn('slow');
            if(current_step === 'delivery_method' || current_step === 'shipping_information' ){
                $('.shipping-providers').fadeOut('fast');
                $('.shipping-form .form-actions').show();
            }
        }else{
            $(this).closest('.acc-content').find('.address-form').fadeOut('slow');

            if($(this).val() !== '' && (current_step === 'delivery_method')){
                get_shipping_methods();
            }else if($(this).val() !== 'new-address' && ( current_step === 'billing_information' || current_step === 'shipping_information')){
                //$('.checkout-next-step:visible').trigger('click');
            }else if($(this).val() === ''){
                $('.shipping-providers').fadeOut('fast');
                $('.shipping-form .form-actions').show();
            }
        }
    });

    $(document).on('change','select[name="address_id"]',function(){
        var value = $(this).find('option:selected').val();
        if(value === 'new-address')	{
            $(this).closest('.acc-content').find('.address-form').fadeIn('slow');
            if(current_step&& ( current_step === 'delivery_method' || current_step === 'shipping_information') ){
                $('.shipping-providers').fadeOut('fast');
                $('.shipping-form .form-actions').show();
            }
        }else{
            $(this).closest('.acc-content').find('.address-form').fadeOut('slow');

            if(value!=='' && ( current_step === 'delivery_method' || current_step === 'shipping_information')){
                get_shipping_methods();
            }else if(value === ''){
                $('.shipping-providers').fadeOut('fast');
                $('.shipping-form .form-actions').show();
            }

        }
    });

    $(document).on('change','input[name="delivery_method"]',function(){
        var method = $(this).val(),keys = [];

        $('input:hidden[name^="delivery_method_"]').each(function(){
            if($(this).data('shippable') === 1){
                $(this).val(method);
                keys.push($(this).data('key')+':'+method);
            }else{
                $(this).val(0);
                keys.push($(this).data('key')+':0');
            }
        });
        register_delivery_method(keys.join(','));
        checkDeliveryMethods();
    });

    $(document).on('change','input[name="billing_method"]',function(e){
        var slc = $(this).val();
        if(slc == 'invoice'){
            $('div[data-if-billing="receipt"]').addClass('hidden');
        }else{
            $('div[data-if-billing="invoice"]').addClass('hidden');
        }
        $('div[data-if-billing="'+slc+'"]').removeClass('hidden');
        e.preventDefault();
    });

    $(document).on('submit','#co-promo-codes-form',function(){
        $.ajax({
            data:$('#co-promo-codes-form').serialize(),
            error:function(){
                form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error','An error occurred');
                $('body .loading').fadeOut('fast',function(){
                    $(this).remove();
                });
            },

            success:function(data){
                if(data.status =='ok'){
                    if(data.total){
                        $('.cart-counter').html(data.total);
                    }
                    if(data.total_bonus){
                        $('.cart-bonus-counter').html(' + '+data.total_bonus).removeClass('hidden');
                    }
                    if(data.total_amount>0){
                        $('.cart-totals').html(currency_format(data.total_amount, CURRENCY_INFO[0]));

                        $('#co-promo-codes-form').closest('.panel').hide();
                        $('#co-promo-codes-form').closest('.panel').prev().hide();
                        get_sidebar(current_step);
                    }else{
                        nextStep();
                    }
                    if(data.callback && data.callback === 'sticky-notice'){
                        form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','sticky-notice',data.notice);
                    }

                    ajaxContent('.mini-cart.ajax-content,.bundle-builders.ajax-content');

                }else if(data.status === 'error'){
                    form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error',data.error);
                    $('body .loading').fadeOut('fast',function(){
                        $(this).remove();
                    });
                }else if(data.status === 'notice'){
                    form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','notice',data.notice);
                    $('body .loading').fadeOut('fast',function(){
                        $(this).remove();
                    });
                }
                return false;
            }
        });

        return false;
    });
});

function validateShippingMethod(){
    if( $('.shipping-providers').is(':visible')){
        if($('form[name="shipping_method"] input:radio:checked').length === 0){
            form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error','No Shipping Selected');
        }else{
            nextStep();
        }
    }else{
        $('.shipping-providers').fadeIn('fast');
        $('.shipping-form .form-actions').hide();
        get_shipping_methods();
    }
}

function checkDeliveryMethods(){
    var should_ship = $('input[name="delivery_method"]:checked').val() > 0 ;
    //var should_ship = $('select[name="delivery_method"] option:selected').val() > 0 ;
    if(should_ship){
        $('#co-delivery-methods-form .form-actions').hide();
        $('.shipping-form').fadeIn('slow');
        skinFormElements('.shipping-form');
    }else{
        $('#co-delivery-methods-form .form-actions').show();
        $('.shipping-form').fadeOut('slow');
    }
}
function get_sidebar(step){

    $.ajax({

        data:{
            module:'sales',
            action:'get_sidebar',
            step:step,
            data_type:'html'
        },
        dataType:'html',
        error:function(){
            form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error','An error occurred');
            $('body .loading').fadeOut('fast',function(){
                $(this).remove();
            });
        },

        success:function(data){
            $('.check-out-sidebar').html(data);
            return false;
        }
    });
}
function register_delivery_method(products){
    $.ajax({

        data:{
            module:'sales',
            action:'register-delivery-method',
            products:products
        },
        error:function(){
            form_submit_response('.acc-content[data-stepcode="'+(current_step)+'"] form','error','An error occurred');
            $('body .loading').fadeOut('fast',function(){
                $(this).remove();
            });
        },

        success:function(data){
            $('.shipping-providers').html(data);
            return false;
        }
    });
}
function get_shipping_methods(){
    $('.shipping-providers').fadeIn('slow');
    $('div[data-stepcode="shipping_information"] .form-actions').hide();
    $('body').prepend('<div class="loading blocking text-center"><span>CHECKING SHIPPING RATES</span></div>');

    var form_data = $('div[data-stepcode="shipping_information"] form[name="address-form"]').serializeArray();
    var form_data_object = {};
    form_data.forEach(function (element) {
        form_data_object[element.name] = element.value;
    });
    $.ajax({

        data:{
            module:'sales',
            action:'get-shipping-methods',
            data_type:'html',
            form_data:form_data_object
        },
        dataType:'html',
        error:function(data){
            $('div[data-stepcode="shipping_information"] .shipping-providers').fadeOut('slow');
            $('div[data-stepcode="shipping_information"] .form-actions').show();
            errorResponse(data,form_data_object);

            $('body .loading').fadeOut('fast',function(){
                $(this).remove();
            });
        },

        success:function(data){
            $('body .loading').fadeOut('fast',function(){
                $(this).remove();
            });
            $('div[data-stepcode="shipping_information"] .shipping-providers').html(data);
            scroll2position($('div[data-stepcode="shipping_information"] .shipping-providers').offset().top);
            skinFormElements('div[data-stepcode="shipping_information"] .shipping-providers');
            return false;
        }
    });
}

function skinFormElements(t){
    initCheckboxes(t);
}

function post(path, parameters) {
    var form = $('<form></form>');

    form.attr("method", "post");
    form.attr("action", path);
    for(var key in parameters){
        var field = $('<input />');
        field.attr("type", "hidden");
        field.attr("name", key);
        field.attr("value", parameters[key]);
        form.append(field);
    }

    $(document.body).append(form);
    form.submit();
}

function scroll2position(pos){
    $('html, body').animate({scrollTop: pos}, 500);
}

function skinDropDowns(){}
